// ----------------------------------------------------------------------------
// Nombre del Programa : SobreNosotros
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 23/JUN/2024
// Descripcion General : Clase que se utiliza para mostrar el resultado de la busqueda
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './Buscador.scss';
import 'react-status-alert/dist/status-alert.css';
import { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ListGroup from 'react-bootstrap/ListGroup';
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { postBusquedaComunicado } from '../../Services/ComunicadosService';
import { BusquedaComunicadoProps, ComunicadosProps } from '../../interfaces/comunicadosInterfaces';
import { useLocation } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import { Button } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';

export const Buscador = () => {

  const [comunicados, setComunicados] = useState<ComunicadosProps[]>([]);
  const [palabraClave, setPalabraClave] = useState('');
  const [cargado, setCargado] = useState<boolean>(false);
  const [OrdenSeleccionado, setOrdenSeleccionado] = useState('ASC');

  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      let _state = location.state as any;
      setPalabraClave(_state.palabraClave);
      if (_state.palabraClave !== "") {
        cargarBusqueda(_state.palabraClave, "");
      }
    }
  }, []);

  useEffect(() => {
  }, []);


  const cargarBusqueda = async (palabra: string, orden: string) => {

    let busquedaComunicados = {} as BusquedaComunicadoProps;

    if (palabra !== "") {
      busquedaComunicados.palabrasClave = palabra;
    }
    else {
      busquedaComunicados.palabrasClave = palabraClave;
    }

    if (orden !== "") {
      busquedaComunicados.order = orden;
    }
    else {
      busquedaComunicados.order = OrdenSeleccionado;
    }

    const response: any = await postBusquedaComunicado(busquedaComunicados).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });

    if (response.data && response.data.data) {
      setCargado(true);
      setComunicados(response.data.data);
      /*if (response.data.data.length <= 0) {
        StatusAlertService.showInfo('No Existen Resultados Para su Busqueda');
      }*/
    }
    else {
      setCargado(true);
      StatusAlertService.showError('No Existen Resultados Para su Busqueda');
    }

  };

  const ordenSeleccionadoUsuario = (event: any) => {
    setOrdenSeleccionado(event.target.value);
    if (cargado) {
      cargarBusqueda("", event.target.value)
    }
  };

  const enterTexto = (target: any) => {
    if (target.key === 'Enter') {
      cargarBusqueda("", "");
    }
  };


  return (
    <>
      <div className="m-3">
        <Row className="botoncentrado mt-3">

          <Col className="minimo300">
            <InputGroup className="mb-3">
              <Button className="btn-buscador" onClick={() => cargarBusqueda("", "")} variant="primary">
                <div className="material-icons">search</div>
              </Button>
              <Form.Control
                className="btn-buscador"
                placeholder="Busca por palabra clave"
                value={palabraClave}
                onChange={(e) => setPalabraClave(e.target.value)}
                onKeyPress={enterTexto}
                aria-describedby="basic-addon1"
              />
            </InputGroup>
          </Col>
        </Row>
        <Row className="botoncentrado mb-3">
          <Col sm={3} className="minimo300">
            <Form.Select
              className="colorwhite"
              value={OrdenSeleccionado}
              onChange={ordenSeleccionadoUsuario}
            >
              <option value="ASC">Orden Ascendente</option>
              <option value="DESC">Orden Descendente</option>
            </Form.Select>
          </Col>
        </Row>
        {comunicados.length > 0 ? (
          comunicados.map((comunicado, index) => (
            <Card key={comunicado.comunicado_id}>
              <Card.Body>
                <Card.Title>{comunicado.titulo}</Card.Title>
                <Card.Text>
                  {moment(comunicado.fechaPublicacion).format('DD/MM/YYYY')}
                </Card.Text>
                <div className="d-flex flex-row-reverse bd-highlight">
                  <Link to={'/vista-comunicado/' + comunicado.comunicado_id}>
                    <Button variant="primary" className="btnveritem">
                      <div className="material-icons veritem">visibility</div>
                    </Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          ))
        ) : cargado ? (
          <Row className="titulo nodatos colorgray2">
            <Col className="heading-1 pt-5">
              No Existen Resultados Para su Busqueda
            </Col>
          </Row>
        ) : (
          <tr></tr>
        )}
      </div>
    </>
  );
};
